<template>
  <div class="my-form-sign">
    <img v-if="signUrl" :src="signUrl" class="my-form-sign___image" />

    <el-link type="primary" :underline="false" icon="EditPen" @click="showDialog = true">绘制</el-link>

    <el-dialog title="请签名" v-model="showDialog" width="fit-content" align-center>
      <div class="my-form-sign__board-wrapper">
        <sign-board ref="boardRef" v-model="dataUrl" :as-default="asDefault" :width="width" :height="height" />
      </div>

      <div class="my-form-sign__action-bar">
        <el-checkbox v-model="asDefault" label="设置为默认" />

        <div class="my-form-sign__action-bar--right">
          <el-link type="primary" size="small" :underline="false" icon="EditPen" @click="boardRef.useDefault()">使用默认签名</el-link>
          <el-link type="warning" size="small" :underline="false" @click="boardRef.reset()" icon="Refresh">重置</el-link>
        </div>
      </div>

      <template #footer>
        <el-button type="info" @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="endDraw">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { isEmpty } from '@safety/shared-utils'
import { ref, computed } from 'vue'
import { getUrl, fileFolder } from '@/util/resource'
import SignBoard from '@/components/SignBoard.vue'

defineExpose({ upload: async () => await boardRef.value?.upload() })

const props = defineProps({
  width: {
    type: Number,
    default: 600
  },
  height: {
    type: Number,
    default: 300
  }
})

const model = defineModel({
  type: Object,
  default: () => ({
    type: 'dataurl', // dataurl, uri
    value: null
  })
})

/**
 * 是否设置为默认签名
 */
const asDefault = ref(false)

const dataUrl = ref(null)

const showDialog = ref(false)

const boardRef = ref(null)

const signUrl = computed(() => {
  if (model.value) {
    const { type, value } = model.value
    return type === 'dataurl' ? value : getUrl(fileFolder.SIGN_IMAGE, value)
  } else {
    return null
  }
})

function endDraw() {
  showDialog.value = false
  if (isEmpty(dataUrl.value)) {
    model.value = null
  } else {
    model.value = { type: 'dataurl', value: dataUrl.value }
  }
}
</script>

<style lang="scss" scoped>
.my-form-sign {
  display: flex;
  align-items: flex-start;
  gap: 10px;

  &___image {
    width: 160px;
    height: 80px;
    object-fit: cover;
    box-sizing: border-box;
    border: var(--my-border);
    border-radius: 5px;
  }

  &__action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;

    &--right {
      display: flex;
      gap: 10px;
    }
  }
}
</style>
